/* ================== 到期学员 （expire_student）================== */
const expire_student_routes = {
      path: "/expireStudent",
      name: "ExpireStudent",
      component: () => import("@/components/LayOut/Main"),
      meta: {requiresAuth: true},
      children: [
        {
          path: "tran_his",
          component: () => import('@/views/training_expire_student/TrainingHis'),
          meta: {requiresAuth: true},
        },
        {
          path: "expire_index",
          component: () => import('@/views/training_expire_student/expireIndex'),
          meta: {requiresAuth: true},
        },
        {
          path: "expire_help",
          component: () => import('@/views/training_expire_student/expireHelp'),
          meta: {requiresAuth: true},
        },
        {
          path: "edit_qualification",
          component: () => import('@/components/Qualification/edit-login-qualification'),
          meta: {requiresAuth: true},
        },
        {
          path: "upload_qualification",
          component: () => import('@/components/Qualification/uploadQualification'),
          meta: {requiresAuth: true},
        },
        {
          path:"expir_record",
          component :() => import('@/views/system_manager/review/record'),
          meta: {requiresAuth: true},
        },
        {
          path: "record_qualification",
          component: () => import('@/views/training_expire_student/record_qualification'),
          meta: {requiresAuth: true},
        },
        {
          path: "tea_sd",
          component: () => import('@/views/training_teacher/stu-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "stu_tutorial",
          component: () => import('@/views/training_teacher/student-tutorial'),
          meta: {requiresAuth: true},
        },
        {
          path: "tutorial_detail",
          component: () => import('@/components/Tutorial/tutorial-detail'),
          meta: {requiresAuth: true},
        },
        {
          path: "vita",
          component: () => import('@/views/training_student/vita/vita'),
          meta: {requiresAuth: true},
        },
          //过期学员页面设置
        // {
        //   path:"dataSetting",
        //   component: () => import('@/views/training_expire_student/dataSetting'),
        //   meta: {requiresAuth: true},
        // },
          //基本设置
        {
          path:"basicSetting",
          component: () => import('@/views/training_expire_student/basicSetting'),
          meta: {requiresAuth: true},
        },
          //资历设置
        {
          path:"qualificationSetting",
          component: () => import('@/views/training_expire_student/qualificationSetting'),
          meta: {requiresAuth: true},
        },
        {
          path:"registrationList",
          component: () => import("@/views/Registration/registration-list"),
          meta:{requiresAuth:true}
        },
        {
          path:"continueList",
          component: () => import("@/views/Registration/continue-list"),
          meta:{requiresAuth:true}
        },
        {
          path: "register_vita",
          component: () => import('@/views/Registration/vita/vita'),
          meta: {requiresAuth: true},
        },
        // 报名详情
        {
          path: "register_info",
          component: () => import('@/components/Registration/RegistrationInfo'),
          meta: {requiresAuth: true},
        },
        // 上传附件
        {
          path: "register_file",
          component: () => import('@/views/Registration/vita/vitaFile'),
          meta: {requiresAuth: true},
        },
        // 上传附件
        {
          path: "enroll_choose_again",
          component: () => import('@/views/Registration/vita/enroll_choose_again'),
          meta: {requiresAuth: true},
        },
        // 提交问题反馈
        {
          path: "submit_question",
          component: () => import('@/views/training_expire_student/SubmitQuestion'),
          meta: {requiresAuth: true},
        },
        {
          path: "getLicenseList",
          component: () => import('@/views/training_expire_student/licenseList'),
          meta: {requiresAuth: true},
        },
        /* 学习资料列表 */
        {
          path:'materials',
          component: () => import('@/views/Materials/Documents'),
          meta: {requiresAuth: true}
        },
        /* 教练员注册申请 */
        {
          path:'alter_avi_list',
          component: () => import('@/views/training_expire_student/alterationOrg/AlterationList'),
          meta: {requiresAuth: true}
        },
        /* 教练员注册申请 复议 */
        {
          path:'alter_avi_fuyi',
          component: () => import('@/views/training_expire_student/alterationOrg/AlterationFuyi'),
          meta: {requiresAuth: true}
        },
        /* 申请通知详细信息 */
        {
          path:'alter_avi_details',
          component: () => import('@/views/training_expire_student/alterationOrg/AlterationItemDetails'),
          meta: {requiresAuth: true}
        },
        /* 申请通知详细信息 提交申请 */
        {
          path:'alter_avi_upload',
          component: () => import('@/views/training_expire_student/alterationOrg/AlterationUpload'),
          meta: {requiresAuth: true}
        },
        /* 继续教育列表 */
        {
          path:'education_list',
          component: () => import('@/views/Education/educationList'),
          meta: {requiresAuth: true}
        },
        /* 进入继续教育详情 */
        {
          path:'education_info_to_stu',
          component: () => import('@/views/Education/educationDetailToStu'),
          meta: {requiresAuth: true}
        },
        /* 继续教育学习页面 */
        {
          path:'education_learn_to_stu',
          component: () => import('@/views/Education/educationLearn'),
          meta: {requiresAuth: true}
        },
        {
          path:"classComplaintAdd",
          name:'ClassComplaintAdd',
          component:()=> import("@/components/ClassComplaint/ClassComplaintAdd"),
          meta: {requiresAuth: true}
        },
        {
          path:"classAppealAdd",
          name:'ClassAppealAdd',
          component:()=> import("@/components/ClassComplaint/ClassAppealAdd"),
          meta: {requiresAuth: true}
        },
        // 测评
        {
          path: 'create_evaluation',
          name: 'StuCreateEvaluation',
          component: () => import('@/views/training_student/CreateEvaluation'),
          props: true,
          meta: {requiresAuth: true},
        },
        // 确认预录取
        {
          path: 'confirmPreAdmission',
          name: 'ConfirmPreAdmission',
          component: () => import('@/views/training_expire_student/confirmPreAdmission'),
          props: true,
          meta: {requiresAuth: true},
        },
        /* 投诉详情 */
        {
          path:'feedbackInfo',
          name: 'FeedbackInfo',
          component: () => import('@/views/system_manager/feedback/components/feedbackInfo'),
          meta: {requiresAuth: true}
        },
        /* 高水平球员认证详情 */
        {
          path:'authenticationInfo',
          name: 'AuthenticationInfo',
          component: () => import('@/components/highPlayerAuthentication/AuthenticationInfo'),
          meta: {requiresAuth: true}
        },
      ]
    }

export default expire_student_routes;
